import { AbstractControl, ValidationErrors } from "@angular/forms";

// Single source of truth for US phone parsing/validation, shared by
// create-sso-profile (phone field) and search-sso-profile (email-or-phone field)
// so both validate identically.

// Reduce any common phone format to its significant digits: strip separators
// (spaces, dashes, parens, dots, +), then drop a leading US country code.
export function phoneDigits(value: unknown): string {
    let digits = (value ?? "").toString().replace(/\D/g, "");
    if (digits.length === 11 && digits.startsWith("1")) {
        digits = digits.slice(1);
    }
    return digits;
}

// A valid US number is 10 significant digits after normalization, one rule for
// every input shape (+1, dashes, spaces, parens, bare).
export function isValidUsPhone(value: unknown): boolean {
    return phoneDigits(value).length === 10;
}

export function phoneValidatorForCountry(control: AbstractControl): ValidationErrors | null {
    const raw = (control.value ?? "").toString().trim();
    if (!raw) {
        return null;
    }
    const country = control.parent?.get("countryCode")?.value?.country;
    if (country === "USA" || country === "CAN") {
        return phoneDigits(raw).length === 10 ? null : { phone: true };
    }
    const digits = raw.replace(/[^0-9]+/g, "");
    return digits.length >= 4 && digits.length <= 15 ? null : { phone: true };
}

// Format up to 10 US digits as (xxx) xxx-xxxx
export function formatUsPhone(digits: string): string {
    const d = digits.slice(0, 10);
    if (d.length <= 3) {
        return d;
    }
    if (d.length <= 6) {
        return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    }
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
